import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const LightBulbIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M12 1a7 7 0 0 0-7 7c0 1.201.295 2.709 1.793 4.207l.032.031a3.61 3.61 0 0 1 1.104 1.958 1 1 0 0 0 1.962-.392 5.61 5.61 0 0 0-1.698-3.026C7.163 9.742 7 8.795 7 8a5 5 0 1 1 10 0v.017a3.648 3.648 0 0 1-1.207 2.776c-.862.862-1.46 1.796-1.686 3.026a1 1 0 1 0 1.966.362c.134-.725.471-1.308 1.12-1.96A5.65 5.65 0 0 0 19 7.99 7 7 0 0 0 12 1ZM8 18a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm1 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Z" />
    </Icon>
  )
);
export default LightBulbIcon;
